<template>
    <div class="modal fade" ref="citySelectModal" id="city-select-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" ref="content">
                <div class="modal-header" ref="header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Закрыть">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Выберите ваш город</h4>
                </div>
                <div class="modal-body" :style="{height: modalBodyMaxHeight}">
                    <div class="form-group" id="vcsm-searchfield-wrapper">
                        <div class="input-group">
                            <input type="text"
                                   class="form-control"
                                   placeholder="Город"
                                   v-model="query"
                                   aria-haspopup="false"
                                   autocapitalize="off"
                                   autocomplete="off"
                                   autocorrect="off"
                                   spellcheck="false"
                            >
                            <button type="button" class="close" aria-label="Close" v-if="query" @click="clearQuery()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="input-group-addon">

                                <svg xmlns="http://www.w3.org/2000/svg" class="" style="height: 1.1rem" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>

                            </div>
                        </div>
                    </div>

                    <div v-if="showError" class="alert alert-danger" role="alert">
                        Произошла ошибка. Попробуйте перезагрузить страницу.
                    </div>

                    <div v-show="showFeatured && !showError">
                        <div class="row hidden-xs" id="vcsm-featured-cities">
                            <div class="col-sm-3" v-for="(chunk, index) in featuredCities">
                                <ul class="list-unstyled" style="margin-bottom: 0;">
                                    <li v-if="index === 0">
                                        <a :href="setLink(lastCity)" class="btn btn-primary" v-text="lastCity.name"></a>
                                    </li>
                                    <li v-for="city in chunk">
                                        <a :href="setLink(city)" class="btn btn-link">
                                            <span v-if="city.show_region" class="as">{{ city.name }} ({{ city.region }})</span>
                                            <span v-else>{{ city.name }}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr class="hidden-xs">

                        <div id="vcsm-regions" class="row" :style="{height: regionsMaxHeight}">
                            <ul class="list-unstyled col-sm-6">
                                <li v-for="region in locations" :id="activeRegionId === region.id ? 'current-region' : ''">
                                    <button type="button"
                                            :class="[activeRegionId === region.id ? 'btn-primary' : 'btn-link', 'btn']"
                                            v-text="region.name"
                                            @click="showRegionCities(region)"
                                    ></button>
                                    <!-- На мобильных устройствах показываем города под названием региона -->
                                    <ul class="list-unstyled visible-xs" v-if="activeRegionId === region.id">
                                        <li v-for="city in regionCities">
                                            <a :href="setLink(city)" class="btn btn-link">
                                                <span v-if="city.show_region" class="as">{{ city.name }} ({{ city.region }})</span>
                                                <span v-else>{{ city.name }}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <ul class="list-unstyled hidden-xs col-sm-6">
                                <li v-for="city in regionCities">
                                    <a :href="setLink(city)" class="btn btn-link">
                                        <span v-if="city.show_region" class="as">{{ city.name }} ({{ city.region }})</span>
                                        <span v-else>{{ city.name }}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-show="showNothingFound" class="alert alert-warning" role="alert">
                        Город не найден
                    </div>
                    <ul class="list-unstyled">
                        <li v-for="city in cities">
                            <a :href="setLink(city)" class="btn btn-link">
                                <span v-if="city.show_region" class="as">{{ city.name }} ({{ city.region }})</span>
                                <span v-else>{{ city.name }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.glyphicon-refresh {
    animation: spin 2s infinite linear;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(359deg);
    }
}

.modal-content {
    overflow: hidden;
}

.modal-body {
    padding-top: 65px;
}

.vcsm-last-city {
    padding-left: 12px;
    margin-bottom: 15px;
}

#vcsm-searchfield-wrapper {
    position: absolute;
    width: calc(100% - 30px);
    left: 15px;
    top: 15px;

    .close {
        position: absolute;
        right: 50px;
        top: 5px;
        z-index: 999;
    }
}

#vcsm-cities-wrapper {
    padding-top: 0;
}

#vcsm-regions {
    width: 100%;
    position: relative;
    overflow: auto;

    ul {
        height: 100%;
        overflow: auto;
        vertical-align: top;
        margin-bottom: 0;

        &:first-child {
            @media(min-width: 768px) {
                border-right: 1px solid #eee;
            }
        }

        li > ul {
            margin-left: 20px;
        }
    }
}
</style>

<script>
/* eslint-disable no-undef */
export default {
    props: {
      force_link_to_root: {
          /*
          Когда не нужно искать город у url и его менять. Просто ссылка на город в корень
           */
          required: false,
          default: false,
          type: Boolean
      }
    },
    data() {
        return {
            isLoaded: false,
            query: '',
            queryStr: '',
            featuredCities: [],
            lastCity: {},
            locations: [],
            regionCities: [],
            activeRegionId: null,
            cities: [],
            showFeatured: true,
            modalBodyMaxHeight: 0,
            regionsMaxHeight: 0,
            showError: false,
            showNothingFound: false,
            cityInUrl: undefined,
        };
    },

    watch: {
        query(val) {
            if (!/^[а-яё ]*$/i.test(val)) {
                this.queryStr = this.autoKeyboardLang(val);
            } else {
                this.queryStr = val;
            }
        },
        filteredData(val) {
            if (val.length !== this.allCities.length && val.length > 0) {
                this.cities = val;
                this.showFeatured = false;
                this.showNothingFound = false;
            } else {
                this.cities = [];
                this.showFeatured = !this.query;
                if (this.query) {
                    this.showNothingFound = true;
                }
            }
        },
    },

    mounted() {
        this.whenReady();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        /**
         * Завершаем загрузку компонента.
         */
        whenReady() {
            const self = this;

            $(this.$el).on('show.bs.modal', () => {
                self.reset();
                if (!self.featuredCities.length > 0) {
                    self.fetchCities();
                    self.fetchAllCities();
                }

                self.setModalSize();
            });

            window.addEventListener('resize', this.handleResize);
        },

        /**
         * Очищаем данные запроса и сбрасываем активный регион.
         */
        reset() {
            this.query = '';
            this.activeRegionId = null;
        },

        handleResize() {
            this.setModalSize();
        },

        /**
         * Устанавливаем размер модального окна.
         */
        setModalSize() {
            const dialogMargin = window.innerWidth < 768 ? 40 : 60;
            const contentHeight = window.innerHeight - (dialogMargin * 2);
            const featuredAndSearchHeight = window.innerWidth < 768 ? 80 : 262;
            this.modalBodyMaxHeight = `${contentHeight}px`;
            this.regionsMaxHeight = `${contentHeight - featuredAndSearchHeight}px`;
        },

        /**
         * Определяем запрос, если раскладка клавиатуры не переключена.
         */
        autoKeyboardLang(str) {
            let string = str;
            const s = [
                'й', 'ц', 'у', 'к', 'е', 'н', 'г', 'ш', 'щ', 'з', 'х', 'ъ',
                'ф', 'ы', 'в', 'а', 'п', 'р', 'о', 'л', 'д', 'ж', 'э',
                'я', 'ч', 'с', 'м', 'и', 'т', 'ь', 'б', 'ю',
            ];

            const r = [
                'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '\\[', '\\]',
                'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', "'",
                'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '\\.',
            ];

            for (let i = 0; i < r.length; i += 1) {
                const reg = new RegExp(r[i], 'mig');
                string = string.replace(reg, a => (a.toLowerCase() ? s[i] : s[i].toUpperCase()));
            }

            return string;
        },

        /**
         * Тянем популярные города + последний город.
         */
        fetchCities() {
            const self = this;
            $.get('/api/get_featured_locations', (data) => {
                self.featuredCities = this.chunk(data.featured_cities, 3);
                self.lastCity = data.last_city;
            }).fail(() => {
                self.showError = true;
            });
        },

        chunk(array, size) {
            const s = Math.max(size, 0);
            const length = array === null ? 0 : array.length;
            if (!length || s < 1) {
                return [];
            }
            let index = 0;
            let resIndex = 0;
            const result = new Array(Math.ceil(length / s));

            while (index < length) {
                result[resIndex += 1] = array.slice(index, (index += s));
            }

            return this.filterArray(result);
        },

        filterArray(array) {
            let index = -1;
            const arrLength = array ? array.length : 0;
            let resIndex = -1;
            const result = [];

            // eslint-disable-next-line no-cond-assign
            while ((index += 1) < arrLength) {
                const value = array[index];

                if (value) {
                    result[resIndex += 1] = value;
                }
            }

            return result;
        },

        /**
         * Тянем все города.
         */
        fetchAllCities() {
            const self = this;
            this.isLoaded = true;
            $.get('/api/get_locations', (response) => {
                self.locations = response;
                self.isLoaded = false;
                this.checkUrlCity();
            }).fail(() => {
                self.showError = true;
            });
        },

        /**
         * Показываем города, принадлежащие регилну.
         */
        showRegionCities(region) {
            this.regionCities = region.cities;
            this.activeRegionId = region.id;
        },

        /**
         * Назначаем ссылку для города.
         * @param city
         */
        setLink(city) {

            if(city['url'] && ! this.force_link_to_root) {
                if (this.cityInUrl) {
                    return window.location.pathname.replace(`/${this.cityInUrl}/`, `/${city['url']}/`) + '?forcecity'
                } else {
                     return window.location.pathname.replace(`/`, `/${city['url']}/`) + '?forcecity'

                }
            } else{
                if (city['url']) {
                     return '/' + city['url'] + '?forcecity'
                }
            }

            return '/?forcecity';
        },

        clearQuery() {
            this.query = '';
            this.showNothingFound = false;
        },

        checkUrlCity() {
            // check is first path segment is city
            if (this.locations.length > 0) {
                // get first path segment
                const firstSegment = window.location.pathname.split('/')[1],
                    lf = require('../helpers/locations')
                // check
                this.cityInUrl = lf.ll(firstSegment, this.locations)
            }
        },

    },
    computed: {
        /**
         * Трансформируем массив всех городов + добавляем дублям название региона.
         * @returns {Array}
         */
        allCities() {
            let cities = [];
            for (let i = 0; i < this.locations.length; i += 1) {
                const regionCities = this.locations[i].cities;

                for (let n = 0; n < regionCities.length; n += 1) {
                    regionCities[n].region = this.locations[i].name;
                }

                cities = cities.concat(regionCities);
            }

            /**
             * Добавляем дублям названия регионов.
             * @type {Array}
             */
            const temp = [];
            for (let i = 0; i < cities.length; i += 1) {
                const index = temp.indexOf(cities[i].name);
                temp.push(cities[i].name);

                if (index !== -1) {
                    cities[index].show_region = true;
                    cities[i].show_region = true;
                }
            }

            return cities;
        },

        /**
         * Фильтруем города по введеным символам в строку поиска.
         */
        filteredData() {
            const query = this.queryStr && this.queryStr.toLowerCase();
            const data = this.allCities;

            // Выбираем соответсвующие поиску
            return data.filter(row => Object.keys(row)
                .some(() => String(row.name).toLowerCase().indexOf(query) > -1));
        },
    },
}
</script>
